var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalPlatforms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 20.875C10.8125 21.2617 11.1133 21.5625 11.5 21.5625H26.625C26.9688 21.5625 27.3125 21.2617 27.3125 20.875V11.25L10.8125 11.25V20.875ZM11.5 5.75L26.625 5.75C28.1289 5.75 29.375 6.99609 29.375 8.5V20.875C29.375 22.4219 28.1289 23.625 26.625 23.625H11.5C9.95312 23.625 8.75 22.4219 8.75 20.875V8.5C8.75 6.99609 9.95312 5.75 11.5 5.75ZM6.6875 10.9062L6.6875 21.9062C6.6875 24.0117 8.36328 25.6875 10.4688 25.6875H24.2188C24.7773 25.6875 25.25 26.1602 25.25 26.7188C25.25 27.3203 24.7773 27.75 24.2188 27.75H10.4688C7.20313 27.75 4.625 25.1719 4.625 21.9062L4.625 10.9062C4.625 10.3477 5.05469 9.875 5.65625 9.875C6.21484 9.875 6.6875 10.3477 6.6875 10.9062Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPlatforms);
export default __webpack_public_path__ + "static/media/total-platforms.c54ff2228fa16a83d9c8f3fad0285f96.svg";
export { ForwardRef as ReactComponent };